// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3uYy0","left":"StickyBox_left___DM--","right":"StickyBox_right__3p3ML"};